import axios from "axios";
import config from "../config";

const { apiServerUrl } = config;

export const getTicketDeskToken = (businessId) => {
  return axios
    .get(`${apiServerUrl}/pwa-ticket-desk/token`, {
      params: {
        businessId,
      },
    })
    .then((response) => response.data);
};
